import React from 'react';

import { tooltipStyle } from './MarketDepthTooltip';
import { ChartMousePosition } from './types';

type TooltipProps = {
  mousePosition: ChartMousePosition;
  yMin: number;
  xScaled?: number;
  yScaled?: number;
};

const tooltipLineStyle = {
  bid: {
    // fill: 'var(--green4)',
    stroke: 'var(--green4)',
    // textAnchor: 'start',
  },
  ask: {
    // fill: 'var(--red3)',
    stroke: 'var(--red3)',
    // textAnchor: 'end',
  },
};

export default function MarketDepthTooltipLine({
  mousePosition,
  xScaled,
  yScaled,
  yMin,
}: TooltipProps) {
  if (!mousePosition || !xScaled || !yScaled) {
    return null;
  }
  const x = xScaled - (mousePosition.type === 'bid' ? 0 : tooltipStyle.width);
  const y = yScaled - tooltipStyle.height - 5;
  const { stroke } =
    mousePosition.type === 'bid' ? tooltipLineStyle.bid : tooltipLineStyle.ask;
  const textX = x + (mousePosition.type === 'bid' ? 0 : tooltipStyle.width);
  // const textDX = mousePosition.type === 'bid' ? '1em' : '-1em';

  return (
    <g>
      <line
        x1={textX}
        y1={yMin}
        x2={textX}
        y2={y + tooltipStyle.height}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="10,10"
      />
      {/* 
        {
          fontSize: 12,
          color: 'var(--white)',
          stroke: 'var(--white)',
        }
      <rect
          x={x}
          y={y}
          height={tooltipStyle.background.height}
          width={tooltipStyle.background.width}
          fill={fill}
          stroke={stroke}
          fillOpacity={forceOpacity || tooltipStyle.background.fillOpacity}
          strokeOpacity={forceOpacity}
        />
        <text
          y={y}
          {...tooltipStyle.text}
          textAnchor={textAnchor}
          opacity={forceOpacity}
        >
          <tspan
            x={textX}
            dx={textDX}
            dy="1.5em"
            fontWeight="bold"
            fill="white"
          >
            Price:{' '}
          </tspan>
          <tspan>
            {mousePosition.xValue.toFixed(8)} {selectedMarket}
          </tspan>
          <tspan
            x={textX}
            dx={textDX}
            dy="1.5em"
            fontWeight="bold"
            fill="white"
          >
            Amount:{' '}
          </tspan>
          <tspan>{mousePosition.cumulativeCount.toFixed(4)}</tspan>
        </text> */}
    </g>
  );
}
